var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-sub-a flex flex-col align-middle content-center",class:[_vm.justify]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }